export default __webpack_public_path__ + "static/media/table-stripe.9eb85fcd.svg";